// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"9ea920b5","453":"1256136b"}[chunkId] + ".chunk.js";
};